// MATRIX MATH HELPERS

export const screenToLocal = (x, y, matrix) => {
    const domPoint = new DOMPoint(x, y);
    return domPoint.matrixTransform(matrix.inverse());
};

export const createTransformMatrix = (data) => {
    // Translate to Center -> Rotate -> Translate back -> Scale
    const cx = data.x + data.width / 2;
    const cy = data.y + data.height / 2;

    return new DOMMatrix()
        .translate(cx, cy)
        .rotate(data.rotation)
        .translate(-cx, -cy)
        .translate(data.x, data.y) // This translate might be redundant if we use bounds? 
    // Wait, data.x/y is top-left.
    // Standard approach: Matrix represents the transform relative to valid origin.
    // For simplicity, let's say the matrix maps the Unit Square or the Initial Bounds to Screen.
    // But typically, we just want to Map interactions.

    // Actually, keeping the matrix consistent with the DOM 'transform' property logic:
    // transform-origin is center.
    // transform: translate(x, y) rotate(r) scale(sx, sy) depends on order.

    // Let's stick to the Plan:
    // startMatrix is cached.
    // interactions modify it.
};

// Helper to determine opposite handle (Pivot)
export const getPivot = (handle, x, y, w, h) => {
    switch (handle) {
        case 'nw': return { x: x + w, y: y + h }; // SE is pivot
        case 'ne': return { x: x, y: y + h }; // SW is pivot
        case 'sw': return { x: x + w, y: y }; // NE is pivot
        case 'se': return { x: x, y: y }; // NW is pivot
        case 'n': return { x: x + w / 2, y: y + h };
        case 's': return { x: x + w / 2, y: y };
        case 'w': return { x: x + w, y: y + h / 2 };
        case 'e': return { x: x, y: y + h / 2 };
        default: return { x: x + w / 2, y: y + h / 2 }; // Center
    }
};
